module.exports = __webpack_public_path__ + "static/media/wood1.2334ba9b.jpg";